// src/components/BoardOfEd/components/Program3300.jsx
import React from "react";
import { ProgramBudget } from "../../../../budget/model/program/ProgramBudget.jsx";

export const PROGRAM_3300_CONFIG = {
  fullName: "SUPPORT SERVICES",
  docId: "3300",

  fieldDefs: [
    // POSITIONS (FTE)
    {
      key: "positionsAdmin",
      label: "Positions – Administrative",
      valueType: "count",
      sources: [{ block: "Positions", key: "Administrative" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsOsha",
      label: "Positions – OSHA Safety Officer",
      valueType: "count",
      sources: [{ block: "Positions", key: "OSHA Safety Officer" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsInfoOrComm",
      label: "Positions – Information / Communication Staff",
      valueType: "count",
      sources: [
        { block: "Positions", key: "Information Specialist" },
        { block: "Positions", key: "Communication Staff" },
      ],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsAdminSupport",
      label: "Positions – Admin / Business Support Staff",
      valueType: "count",
      sources: [
        { block: "Positions", key: "Admin/Business Support Staff" },
      ],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsSecurity",
      label: "Positions – Security Services",
      valueType: "count",
      sources: [{ block: "Positions", key: "Security Services" }],
      group: "positions",
      defaultVisible: false,
    },

    // SALARIES
    {
      key: "salariesAdmin",
      label: "Salaries – Administrative",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Administrative" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesAdminSupport",
      label: "Salaries – Admin/Business Support Staff",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Admin/Business Support Staff" },
      ],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesInfoOrComm",
      label: "Salaries – Information / Communication Staff",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Information Specialist" },
        { block: "Salaries", key: "Communication Staff" },
      ],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesSecurity",
      label: "Salaries – Security Services",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Security Services" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesSecretarialPartTime",
      label: "Salaries – Secretarial, Part-Time",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Secretarial, Part-Time" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesSecretarialOvertime",
      label: "Salaries – Secretarial, Over-Time",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Secretarial, Over-Time" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesTutorSteamLab",
      label: "Salaries – Tutor STEAM Lab",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Tutor STEAM Lab" },
        { block: "Salaries", key: "Tutor Steam Lab" },
        { block: "Salaries", key: "Tutor STEM Lab" },
      ],
      group: "salaries",
      defaultVisible: false,
    },

    // PURCHASED SERVICES
    {
      key: "psAudit",
      label: "Audit",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Audit" }],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "psLegalFees",
      label: "Legal Fees",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Legal Fees" }],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "psResearch",
      label: "Research / Redistrict",
      valueType: "currency",
      sources: [
        { block: "Purchased Services", key: "Research" },
        { block: "Purchased Services", key: "Research/Redistrict" },
      ],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "psEquipMaint",
      label: "Equipment Maintenance",
      valueType: "currency",
      sources: [
        { block: "Purchased Services", key: "Equipment Maintenance" },
      ],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "psCopiers",
      label: "Copiers",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Copiers" }],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "psLiability",
      label: "Liability Insurance",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Liability Insurance" }],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "psFidelityBond",
      label: "Fidelity Bond",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Fidelity Bond" }],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "psInsuranceDeductibles",
      label: "Insurance Deductibles",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Insurance Deductibles" }],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "psPublicInfo",
      label: "Public Information",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Public Information" }],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "psPostage",
      label: "Postage",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Postage" }],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "psAdvertising",
      label: "Advertising / Recruiting",
      valueType: "currency",
      sources: [
        { block: "Purchased Services", key: "Advertising/Recruiting" },
      ],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "psPrinting",
      label: "Printing",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Printing" }],
      group: "purchased Services",
      defaultVisible: false,
    },
    {
      key: "psAdultEdMandated",
      label: "Adult Education (Mandated)",
      valueType: "currency",
      sources: [
        { block: "Purchased Services", key: "Adult Education (Mandated)" },
      ],
      group: "purchased Services",
      defaultVisible: false,
    },

    // SUPPLIES / MATERIALS
    {
      key: "suppliesPublications",
      label: "Publications",
      valueType: "currency",
      sources: [{ block: "Supplies / Materials", key: "Publications" }],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "suppliesGeneral",
      label: "Supplies",
      valueType: "currency",
      sources: [{ block: "Supplies / Materials", key: "Supplies" }],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "suppliesSecurity",
      label: "Security Supplies",
      valueType: "currency",
      sources: [{ block: "Supplies / Materials", key: "Security Supplies" }],
      group: "materials",
      defaultVisible: false,
    },

    // OTHER
    {
      key: "otherBoardExpenses",
      label: "Board of Educ. Expenses",
      valueType: "currency",
      sources: [{ block: "Other", key: "Board of Educ. Expenses" }],
      group: "other",
      defaultVisible: false,
    },
    {
      key: "otherSuptOffice",
      label: "Supt. Office Expenses",
      valueType: "currency",
      sources: [{ block: "Other", key: "Supt. Office Expenses" }],
      group: "other",
      defaultVisible: false,
    },
    {
      key: "otherSchoolFoods",
      label: "School Foods Service Dept.",
      valueType: "currency",
      sources: [{ block: "Other", key: "School Foods Service Dept." }],
      group: "other",
      defaultVisible: false,
    },
    {
      key: "otherProfMembership",
      label: "Professional Membership",
      valueType: "currency",
      sources: [
        { block: "Other", key: "Professional Membership/Sy" },
        { block: "Other", key: "Professional Membership/SY" },
      ],
      group: "other",
      defaultVisible: false,
    },
    {
      key: "otherProfExpenses",
      label: "Professional Expenses",
      valueType: "currency",
      sources: [{ block: "Other", key: "Professional Expenses" }],
      group: "other",
      defaultVisible: false,
    },
    {
      key: "otherTravel",
      label: "Travel",
      valueType: "currency",
      sources: [{ block: "Other", key: "Travel" }],
      group: "other",
      defaultVisible: false,
    },
    {
      key: "otherCabeDues",
      label: "CABE Dues",
      valueType: "currency",
      sources: [{ block: "Other", key: "CABE Dues" }],
      group: "other",
      defaultVisible: false,
    },
    {
      key: "otherCrecDues",
      label: "CREC Dues",
      valueType: "currency",
      sources: [{ block: "Other", key: "CREC Dues" }],
      group: "other",
      defaultVisible: false,
    },

    // EQUIPMENT
    {
      key: "equipNewRplc",
      label: "New/RPLC Equipment (Systemwide)",
      valueType: "currency",
      sources: [
        {
          block: "Equipment",
          key: "New/RPLC Equipment (Systemwide)",
        },
      ],
      group: "equipment",
      defaultVisible: false,
    },
    {
      key: "equipSteam",
      label: "Steam",
      valueType: "currency",
      sources: [{ block: "Equipment", key: "Steam" }],
      group: "equipment",
      defaultVisible: false,
    },
  ],

  tables: [
    {
      id: "approved",
      title: "Approved Budget",
      sectionKey: "Approved",
      fields: [
        // Positions
        "positionsAdmin",
        "positionsOsha",
        "positionsInfoOrComm",
        "positionsAdminSupport",
        "positionsSecurity",

        // Salaries
        "salariesAdmin",
        "salariesAdminSupport",
        "salariesInfoOrComm",
        "salariesSecurity",
        "salariesSecretarialPartTime",
        "salariesSecretarialOvertime",
        "salariesTutorSteamLab",

        // Purchased Services
        "psAudit",
        "psLegalFees",
        "psResearch",
        "psEquipMaint",
        "psCopiers",
        "psLiability",
        "psFidelityBond",
        "psInsuranceDeductibles",
        "psPublicInfo",
        "psPostage",
        "psAdvertising",
        "psPrinting",
        "psAdultEdMandated",

        // Supplies / Materials
        "suppliesPublications",
        "suppliesGeneral",
        "suppliesSecurity",

        // Other
        "otherBoardExpenses",
        "otherSuptOffice",
        "otherSchoolFoods",
        "otherProfMembership",
        "otherProfExpenses",
        "otherTravel",
        "otherCabeDues",
        "otherCrecDues",

        // Equipment & Grant
        "equipNewRplc",
        "equipSteam"
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsAdmin: { minWidth: "120px" },
        positionsOsha: { minWidth: "140px" },
        positionsInfoOrComm: { minWidth: "180px" },
        positionsAdminSupport: { minWidth: "210px" },
        positionsSecurity: { minWidth: "150px" },

        // Salaries
        salariesAdmin: { minWidth: "130px" },
        salariesAdminSupport: { minWidth: "200px" },
        salariesInfoOrComm: { minWidth: "190px" },
        salariesSecurity: { minWidth: "150px" },
        salariesSecretarialPartTime: { minWidth: "170px" },
        salariesSecretarialOvertime: { minWidth: "180px" },
        salariesTutorSteamLab: { minWidth: "160px" },

        // Purchased Services
        psAudit: { minWidth: "90px" },
        psLegalFees: { minWidth: "100px" },
        psResearch: { minWidth: "120px" },
        psEquipMaint: { minWidth: "120px" },
        psCopiers: { minWidth: "90px" },
        psLiability: { minWidth: "120px" },
        psFidelityBond: { minWidth: "120px" },
        psInsuranceDeductibles: { minWidth: "120px" },
        psPublicInfo: { minWidth: "120px" },
        psPostage: { minWidth: "90px" },
        psAdvertising: { minWidth: "120px" },
        psPrinting: { minWidth: "90px" },
        psAdultEdMandated: { minWidth: "140px" },

        // Supplies / Materials
        suppliesPublications: { minWidth: "120px" },
        suppliesGeneral: { minWidth: "90px" },
        suppliesSecurity: { minWidth: "90px" },

        // Other
        otherBoardExpenses: { minWidth: "130px" },
        otherSuptOffice: { minWidth: "120px" },
        otherSchoolFoods: { minWidth: "210px" },
        otherProfMembership: { minWidth: "120px" },
        otherProfExpenses: { minWidth: "120px" },
        otherTravel: { minWidth: "90px" },
        otherCabeDues: { minWidth: "90px" },
        otherCrecDues: { minWidth: "90px" },

        // Equipment & Grant
        equipNewRplc: { minWidth: "170px" },
        equipSteam: { minWidth: "100px" }
      },
    },
    {
      id: "actual",
      title: "Actual Spending",
      sectionKey: "Actual",
      fields: [
        // Positions
        "positionsAdmin",
        "positionsOsha",
        "positionsInfoOrComm",
        "positionsAdminSupport",
        "positionsSecurity",

        // Salaries
        "salariesAdmin",
        "salariesAdminSupport",
        "salariesInfoOrComm",
        "salariesSecurity",
        "salariesSecretarialPartTime",
        "salariesSecretarialOvertime",
        "salariesTutorSteamLab",

        // Purchased Services
        "psAudit",
        "psLegalFees",
        "psResearch",
        "psEquipMaint",
        "psCopiers",
        "psLiability",
        "psFidelityBond",
        "psInsuranceDeductibles",
        "psPublicInfo",
        "psPostage",
        "psAdvertising",
        "psPrinting",
        "psAdultEdMandated",

        // Supplies / Materials
        "suppliesPublications",
        "suppliesGeneral",
        "suppliesSecurity",

        // Other
        "otherBoardExpenses",
        "otherSuptOffice",
        "otherSchoolFoods",
        "otherProfMembership",
        "otherProfExpenses",
        "otherTravel",
        "otherCabeDues",
        "otherCrecDues",

        // Equipment & Grant
        "equipNewRplc",
        "equipSteam",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsAdmin: { minWidth: "120px" },
        positionsOsha: { minWidth: "140px" },
        positionsInfoOrComm: { minWidth: "180px" },
        positionsAdminSupport: { minWidth: "210px" },
        positionsSecurity: { minWidth: "150px" },

        // Salaries
        salariesAdmin: { minWidth: "130px" },
        salariesAdminSupport: { minWidth: "200px" },
        salariesInfoOrComm: { minWidth: "190px" },
        salariesSecurity: { minWidth: "150px" },
        salariesSecretarialPartTime: { minWidth: "170px" },
        salariesSecretarialOvertime: { minWidth: "180px" },
        salariesTutorSteamLab: { minWidth: "160px" },

        // Purchased Services
        psAudit: { minWidth: "90px" },
        psLegalFees: { minWidth: "100px" },
        psResearch: { minWidth: "120px" },
        psEquipMaint: { minWidth: "120px" },
        psCopiers: { minWidth: "90px" },
        psLiability: { minWidth: "120px" },
        psFidelityBond: { minWidth: "120px" },
        psInsuranceDeductibles: { minWidth: "120px" },
        psPublicInfo: { minWidth: "120px" },
        psPostage: { minWidth: "90px" },
        psAdvertising: { minWidth: "120px" },
        psPrinting: { minWidth: "90px" },
        psAdultEdMandated: { minWidth: "140px" },

        // Supplies / Materials
        suppliesPublications: { minWidth: "120px" },
        suppliesGeneral: { minWidth: "90px" },
        suppliesSecurity: { minWidth: "90px" },

        // Other
        otherBoardExpenses: { minWidth: "130px" },
        otherSuptOffice: { minWidth: "120px" },
        otherSchoolFoods: { minWidth: "210px" },
        otherProfMembership: { minWidth: "120px" },
        otherProfExpenses: { minWidth: "120px" },
        otherTravel: { minWidth: "90px" },
        otherCabeDues: { minWidth: "90px" },
        otherCrecDues: { minWidth: "90px" },

        // Equipment & Grant
        equipNewRplc: { minWidth: "170px" },
        equipSteam: { minWidth: "100px" }
      },
    },
  ],
};

export function Program3300(props) {
  return (
    <ProgramBudget programId="3300" config={PROGRAM_3300_CONFIG} {...props} />
  );
}

export default Program3300;
